import partition from 'lodash/partition'

type SluggedDatum = { slug: string }

export const orderBySlug = <T extends SluggedDatum>(
  sluggedData: readonly T[] = [],
  topSlugs: readonly string[]
): T[] => {
  const [top, rest] = partition(sluggedData, ({ slug }) =>
    topSlugs.includes(slug)
  )

  const orderedTop = topSlugs.reduce((acc, slug) => {
    const matching = top.find((datum) => datum.slug === slug)

    if (!matching) {
      return acc
    }

    return [...acc, matching]
  }, [] as typeof sluggedData)

  return [...orderedTop, ...rest]
}

export const getPriceTitle = (filters: GQL_SearchFilters) => {
  if (
    (filters.startDate && filters.endDate) ||
    filters.weekendMonths?.length > 0
  ) {
    return 'Total price'
  }

  switch (filters.type) {
    case 'accommodation':
      return 'Price per night'
    case 'experiences':
      return 'Price per person'
    default:
      return 'Price per day'
  }
}
